var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',_vm._l((_vm.links),function(link){return _c('v-tab',{key:link.name,staticClass:"px-6 d-none d-sm-flex",attrs:{"id":"link","to":link.to}},[_vm._v(" "+_vm._s(link.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }